import { Component, ErrorInfo, ReactNode } from "react";
import { Link } from "react-router-dom";

export default class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-obsidian px-6 text-center">
          <p className="font-serif text-3xl text-zinc-100">Something came undone.</p>
          <p className="text-zinc-400">Please refresh — or head back to the homepage.</p>
          <Link to="/" className="btn-gold mt-2" data-testid="error-home-link">
            Back to home
          </Link>
        </div>
      );
    }
    return this.props.children;
  }
}
